import { render, staticRenderFns } from "./BarRect.vue?vue&type=template&id=3e1fc3ba&scoped=true"
import script from "./BarRect.vue?vue&type=script&lang=js"
export * from "./BarRect.vue?vue&type=script&lang=js"
import style0 from "./BarRect.vue?vue&type=style&index=0&id=3e1fc3ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1fc3ba",
  null
  
)

export default component.exports